var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-image',_vm._b({attrs:{"lazy-load":""},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true}])},'van-image',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }